<template>
  <div class="echart">
  </div>
</template>

<script>

export default {
  name: '',
  data () {
    return {
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            data: [],
            type: 'line'
          }
        ]
      }
    }
  },

  props: {
    data: {
      datafault: [],
      type: Array
    }
  },

  watch: {
    data: {
      deep: true,
      handler (datas) {
        this.parsingData(datas)
      }
    }
  },

  mounted () {
    this.initEchart()
  },

  methods: {
    initEchart () {
      this.myChart = this.$echarts.init(document.getElementsByClassName('echart')[0])
      this.myChart.setOption(this.option)
    },
    parsingData (datas) {
      const date = []
      const data = []
      datas.forEach(item => {
        date.push(item.date)
        data.push(item.total)
      })
      this.option.xAxis.data = [...date]
      this.option.series[0].data = [...data]
      this.myChart.setOption(this.option)
    }
  }
}
</script>
<style lang='scss' scoped>
  .echart{
    height: 400px;
  }
</style>
